import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Home";
import About from "./About";
import Shop from "./Shop";
import Contact from "./Contact";
import WhishList from "./WhishList";
import Cart from "./Cart";
import { Fragment } from "react/jsx-runtime";
import Mobilehandelr from "./Mobilehandelr";
import "swiper/css";
import Linkes from "./Linkes";
import Lodingpage from "./Lodingpage";
import { useEffect, useState } from "react";
import ProdectDetels from "./ProdectDetels";
import Error from "./Error";
import AddCart from "./AddCart";
import { ToastContainer } from "react-toastify";

function App() {
  let [isloading, setisloading] = useState(false);
  let Router = createBrowserRouter([
    {
      path: "",
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: "/about", element: <About /> },
        { path: "/shop", element: <Shop /> },
        { path: "/shop/:slug", element: <ProdectDetels /> },
        { path: "/Contact", element: <Contact /> },
        { path: "/whishList", element: <WhishList /> },
        { path: "/cart", element: <Cart /> },
        { path: "/AddCart", element: <AddCart /> },
        { path: "*", element: <Error /> },
      ],
    },
  ]);
  useEffect(() => {
    setisloading(true);
    setTimeout(() => {
      setisloading(false);
    }, 4000);
  }, []);
  return (
    <Fragment>
      <Mobilehandelr>
        {isloading ? <Lodingpage /> : <RouterProvider router={Router} />}
        <ToastContainer position="bottom-right" autoClose={2000} />;
        <Linkes />
      </Mobilehandelr>
    </Fragment>
  );
}

export default App;
